export default __webpack_public_path__ + "static/media/frame-login.9ba04be8.png";